import { setTheme } from "theme/default/setTheme";

export const setColor_458cce = setTheme(({ theme }) => `color: ${theme.colors.color_458cce}`);
